export const SET_COMMON_DATA = "SET_COMMON_DATA"
